import { FormattedMessage, useIntl } from 'react-intl';
import type { ReactNode } from 'react';

export default function PaymentTimeoutError() {
  const intl = useIntl();
  const supportEmail = intl.formatMessage({ id: 'email.support' });

  return (
    <FormattedMessage
      id="wallet.payment.timeout"
      values={{
        supportLink: (chunks: ReactNode) => (
          <a href={`mailto:${supportEmail}`} className="underline">{chunks}</a>
        ),
      }}
    />
  );
}
